import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from "@material-ui/core";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { APIError } from "../../components/APIError";

import { useAccountBills } from "./hooks/useAccountBills";
import { BillDetails } from "../../api/services";
import { BillRow } from "./components/BillRow";
import {
  CustomPaginatedTableContainer,
  ColumnHead,
  LoadingRow,
} from "../../components/CustomTableComponents";

export const Bills: React.FC = () => {
  const { accountNumber } = useParams();
  const {
    page,
    pageSize,
    setPage,
    count,
    data: bills,
    status,
    error,
  } = useAccountBills(accountNumber);

  return (
    <>
      <Helmet>
        <title>{accountNumber} - Account Financials: Bills</title>
      </Helmet>
      {error ? (
        <APIError title="We could not load bills for this account." />
      ) : (
        <CustomPaginatedTableContainer
          maxWidth="1280px"
          width="100%"
          paginationProps={{
            page,
            pageSize,
            count,
            setPage,
          }}
        >
          <Table>
            <TableHead data-testid="Bills__TableHead">
              <TableRow>
                <ColumnHead boxProps={{ width: "128px" }}>Date</ColumnHead>
                <ColumnHead boxProps={{ width: "128px" }}>Type</ColumnHead>
                <ColumnHead boxProps={{ width: "256px" }}>Period</ColumnHead>
                <ColumnHead boxProps={{ width: "160px" }}>Status</ColumnHead>
                <ColumnHead boxProps={{ width: "128px", textAlign: "right" }}>
                  Amount
                </ColumnHead>
                <ColumnHead boxProps={{ width: "128px" }}>Due</ColumnHead>
                <ColumnHead>Actions</ColumnHead>
              </TableRow>
            </TableHead>
            <TableBody>
              {status === "loading" ? (
                <LoadingRow col={7} />
              ) : bills && bills.length > 0 ? (
                bills!.map((bill: BillDetails) => (
                  <BillRow bill={bill} key={bill.number} />
                ))
              ) : (
                bills && (
                  <TableRow>
                    <TableCell colSpan={7}>
                      No bills for this account.
                    </TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        </CustomPaginatedTableContainer>
      )}
    </>
  );
};
